import React from 'react';

import SearchTag from './SearchTag';
import { SearchTagType } from '@/graphql/contracts/_generated_/contracts';

interface ISearchTags {
  searchTags: SearchTagType[]
}

function SearchTagsContainer({ searchTags }: ISearchTags) {
  return (
    <>
      {searchTags.map(tag => <SearchTag key={tag.tagId} searchTag={tag} />)}
    </>
  );

}

export default SearchTagsContainer;